// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@bg/XDL/PreStyle/typography";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = Partial<WidgetProps> & HasProduct;

export interface ProductDetailsBrandStyles {
    wrapper?: InjectableCss;
    labelText?: TypographyPresentationProps;
    brandName?: TypographyPresentationProps;
}

export const productBrandStyles: ProductDetailsBrandStyles = {
    wrapper: {
        css: css`
            display: flex;
        `,
    },
    labelText: {
        size: fontConfig.fontSize.small,
        lineHeight: "20px",
        weight: fontConfig.weight.bold,
    },
    brandName: { size: fontConfig.fontSize.small, lineHeight: "20px" },
};

const styles = productBrandStyles;

const ProductDetailUPC: React.FC<Props> = ({ product }) => {
    if (!product || !product.detail?.upcCode) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.labelText}>{translate("UPC:")}&nbsp;</Typography>
            <Typography {...styles.brandName}>{product.detail.upcCode}</Typography>
        </StyledWrapper>
    );
};

export const ProductDetailUPCComponent: React.FC<Props> = ProductDetailUPC;

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailUPC),
    definition: {
        displayName: "Product UPC Number",
        group: "XNGAGE" as any,
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
